import { APIS } from "../../../_config";
import { CallApi } from "../callApi";

export interface RegionFormData {
  name: string;
  region_code: string;
  country_id: string;
  country_name?: string;
}

export interface Region {
  id: string;
  name: string;
  region_code: string;
  country_id: string;
  country_name: string;
  created_at: string;
  updated_at: string;
}

export function useRegionApi() {
  // List regions
  const getRegionList = async (params: any = {}): Promise<any> => {
    const response = await CallApi.GET(APIS.LOCATION_SETTINGS.REGION.REGIONS, params, true);
    return response;
  };

  // Get single region by ID
  const getRegionById = async (id: string): Promise<any> => {
    const response = await CallApi.GET(APIS.LOCATION_SETTINGS.REGION.DETAIL(id), {}, true);
    return response;
  };

  // Create region
  const createRegion = async (data: RegionFormData): Promise<any> => {
    const response = await CallApi.POST(APIS.LOCATION_SETTINGS.REGION.REGIONS, data, true);
    return response;
  };

  // Update region
  const updateRegion = async (id: string, data: RegionFormData): Promise<any> => {
    const response = await CallApi.PUT(APIS.LOCATION_SETTINGS.REGION.DETAIL(id), data, true);
    return response;
  };

  // Delete region
  const deleteRegion = async (id: string): Promise<any> => {
    const response = await CallApi.DELETE(APIS.LOCATION_SETTINGS.REGION.DETAIL(id), true);
    return response;
  };

  return {
    getRegionList,
    getRegionById,
    createRegion,
    updateRegion,
    deleteRegion,
  };
}
